var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Car_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.02 61"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M3.43 5h52v52h-52z"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M15.43 40a3 3 0 1 0-3-3 3 3 0 0 0 3 3m0-5a2 2 0 1 1-2 2 2 2 0 0 1 2-2"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M43.43 40a3 3 0 1 0-3-3 3 3 0 0 0 3 3m0-5a2 2 0 1 1-2 2 2 2 0 0 1 2-2"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M29.43 37a1 1 0 1 0-1-1 1 1 0 0 0 1 1"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M45.42 43.29A.35.35 0 0 0 45 43a19.47 19.47 0 0 1-2.25.28.35.35 0 0 0-.33.37.36.36 0 0 0 .35.34 18.94 18.94 0 0 0 2.34-.29.36.36 0 0 0 .28-.42"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M16.1 43.29a19.47 19.47 0 0 1-2.25-.29.36.36 0 0 0-.42.28.36.36 0 0 0 .28.42 19.35 19.35 0 0 0 2.35.29.36.36 0 0 0 .35-.34.35.35 0 0 0-.33-.37"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M26.46 28.7a.42.42 0 0 0 .39.3.45.45 0 0 0 .15 0l9.15-4a.5.5 0 0 0 .24-.62.42.42 0 0 0-.55-.27l-9.15 4a.49.49 0 0 0-.24.62"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M21.85 28a.45.45 0 0 0 .15 0l9.15-4a.5.5 0 0 0 .24-.62.42.42 0 0 0-.55-.27l-9.15 4a.49.49 0 0 0-.24.62.42.42 0 0 0 .39.3"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M33 45c-.62 0-1.27.07-1.92.09h-.19c-2.18.07-4.52 0-7-.09a.44.44 0 1 0 0 .88c1.64.08 3.23.12 4.76.12h2.46l1.89-.12a.44.44 0 1 0 0-.88"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "Car_svg__clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-2",
    d: "M54.52 49.2h-6.59v-3.75a3.44 3.44 0 0 0 .53-1.28 24.6 24.6 0 0 0 .12-8.39 6 6 0 0 0-2.89-4.34c0-.15-.1-.34-.17-.57l2.63-.29a2 2 0 0 0 1.71-2 2.45 2.45 0 0 0-2.17-2.33l-1.4-.17a2.33 2.33 0 0 0-2 .79c-1.18-3.38-2.58-6.54-3.93-7.44C38.48 18.19 30.94 18 29.44 18s-9 .19-10.88 1.4c-1.35.9-2.75 4.06-3.92 7.44a2.33 2.33 0 0 0-2-.79l-1.41.17A2.45 2.45 0 0 0 9 28.55a1.93 1.93 0 0 0 1.71 2l2.63.29c-.07.22-.12.41-.17.57a6 6 0 0 0-2.89 4.34 24.69 24.69 0 0 0 .11 8.4 3.85 3.85 0 0 0 .53 1.27v3.78H4.34a.9.9 0 1 0 0 1.8h50.18a.9.9 0 1 0 0-1.8Zm-12.63 0H17.12v-1.75l2.43.19h.48c3 .22 6.13.33 9.26.33h.31c3.2 0 6.39-.12 9.48-.35h.19l2.6-.2Zm-2.73-3.37h-.2c-3.19.22-6.4.33-9.53.34h-.76c-2.72 0-5.51-.12-8.3-.3H19.71c-1.45-.11-2.89-.25-4.3-.4l-1.69-.2a1.85 1.85 0 0 1-1.29-.79 2 2 0 0 1-.26-.63c-.09-.43-.16-.88-.22-1.33 4.12.4 8.26.66 12.35.78v.31a.46.46 0 0 0 .46.47h9.28a.47.47 0 0 0 .46-.47v-.29c4.13-.1 8.28-.37 12.35-.8-.06.45-.13.9-.22 1.33a1.77 1.77 0 0 1-.27.63 1.81 1.81 0 0 1-1.28.79l-1.69.2c-1.39.12-2.79.26-4.23.36Zm-13.93-5.46h8.4v2.76h-8.4Zm20.31-12.18a.49.49 0 0 1 .47-.35h.07l1.4.17a.66.66 0 0 1 .58.63.13.13 0 0 1-.11.13l-2.65.3Zm-26-7.29c.57-.38 3.76-1 9.88-1.1 6.12.09 9.31.72 9.88 1.1a.75.75 0 0 1 .14.12A171.94 171.94 0 0 0 19.4 21Zm-.86 1.1a173.12 173.12 0 0 1 21.49 0 38.72 38.72 0 0 1 2.91 7.17c-9.19-.19-18.37-.19-27.31 0A38 38 0 0 1 18.68 22Zm-3 8.53a.94.94 0 0 0 .09-.44c9-.19 18.16-.19 27.38 0a.9.9 0 0 0 .12.5 5.77 5.77 0 0 0-1.07.66 2.52 2.52 0 0 0-.41.39 30.38 30.38 0 0 0-2.09 2.82 5.56 5.56 0 0 1-4.59 2.37c-2.16.14-4.27.11-5.34.09-1.07 0-3.18.05-5.35-.09a5.68 5.68 0 0 1-4.59-2.38c-.49-.76-1.56-2.2-2-2.76a2.64 2.64 0 0 0-.57-.49 4.65 4.65 0 0 0-1.54-.66l-.08-.03Zm-4.73-1.74a.12.12 0 0 1-.11-.12.65.65 0 0 1 .57-.62l1.41-.17h.06a.5.5 0 0 1 .48.35l.25.86ZM12.08 36a4.23 4.23 0 0 1 2.28-3.18.92.92 0 0 0 .45-.54v-.13c.05-.17.13-.43.23-.78a2.72 2.72 0 0 1 1.66.63 1.74 1.74 0 0 1 .36.31c.46.54 1.49 1.94 2 2.67a6.58 6.58 0 0 0 5.3 2.79c1.34.08 2.65.11 3.72.11h1.69c1.08 0 3.22 0 5.41-.09a6.74 6.74 0 0 0 5.31-2.81 31 31 0 0 1 2-2.7 1.6 1.6 0 0 1 .27-.25 4.62 4.62 0 0 1 1-.62c.14.45.23.77.27.93a.91.91 0 0 0 .46.57A4.23 4.23 0 0 1 46.78 36a26.62 26.62 0 0 1 .27 4.62c-4.12.43-8.32.71-12.5.82v-1.52a.47.47 0 0 0-.46-.46h-9.3a.46.46 0 0 0-.46.46v1.52c-4.13-.13-8.32-.4-12.49-.8a26.73 26.73 0 0 1 .24-4.64Zm2.66 13.2a.35.35 0 0 0-.11-.1l-.35-.23.51-.45a.46.46 0 0 0 .14-.4.44.44 0 0 0-.25-.34l-.84-.39a.46.46 0 0 0-.58.13.44.44 0 0 0 .18.67l.23.11-.45.4a.43.43 0 0 0-.14.37.35.35 0 0 0 .08.22h-.39v-2.33a3.78 3.78 0 0 0 .74.17l.82.1a1 1 0 0 0 .29.09l.69.06v1.91Zm31 0a.35.35 0 0 0-.11-.1l-.35-.23.5-.45a.44.44 0 0 0 .15-.4.44.44 0 0 0-.25-.34l-.84-.39a.46.46 0 0 0-.58.13.45.45 0 0 0 .17.67l.24.11-.45.4a.46.46 0 0 0-.22.4.43.43 0 0 0 .09.22h-.39v-1.95h.54a1 1 0 0 0 .3-.09l.81-.1a3.72 3.72 0 0 0 .75-.17v2.33Z"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Car_svg__cls-2{fill:none;clip-rule:evenodd}.Car_svg__cls-6{fill:#061d2d}"))), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M7.43 29h16v16h-16z",
    style: {
      clipPath: "url(#Car_svg__clip-path-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M35.43 29h16v16h-16z",
    style: {
      clipPath: "url(#Car_svg__clip-path-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M23.43 30h12v12h-12z",
    style: {
      clipPath: "url(#Car_svg__clip-path-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M37.43 38h13v11h-13z",
    style: {
      clipPath: "url(#Car_svg__clip-path-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M8.43 38h13v11h-13z",
    style: {
      clipPath: "url(#Car_svg__clip-path-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M21.43 19h20v15h-20z",
    style: {
      clipPath: "url(#Car_svg__clip-path-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M16.43 18h20v15h-20z",
    style: {
      clipPath: "url(#Car_svg__clip-path-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M18.43 40h20v11h-20z",
    style: {
      clipPath: "url(#Car_svg__clip-path-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "Car_svg__cls-6",
    d: "M-1.57 13h62v43h-62z",
    style: {
      clipPath: "url(#Car_svg__clip-path-10)"
    }
  }));
};
export default SvgCar;